module.exports = __webpack_public_path__ + "img/gigilogo.704221d3.png";